import React, { useState } from "react";
import { Modal } from "./Modal";
import { Button } from "./Controls";
import { toast } from "./Toast";
import { errorMessage } from "../api/client";

export function ConfirmDialog({ open, title, message, confirmLabel = "Confirmar", danger, onConfirm, onClose }: {
  open: boolean;
  title: string;
  message: React.ReactNode;
  confirmLabel?: string;
  danger?: boolean;
  onConfirm: () => Promise<unknown> | unknown;
  onClose: () => void;
}) {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      await onConfirm();
      onClose();
    } catch (e) {
      toast.error(errorMessage(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      testId="confirm-dialog"
      footer={
        <>
          <Button variant="secondary" onClick={onClose} data-testid="confirm-cancel-button">Cancelar</Button>
          <Button variant={danger ? "danger" : "primary"} onClick={run} loading={busy} data-testid="confirm-accept-button">{confirmLabel}</Button>
        </>
      }
    >
      <div className="text-sm text-slate-600">{message}</div>
    </Modal>
  );
}
